import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Heartbeat + live list of who is editing a page. Polls every 5s.
export function useEditorPresence(projectId, device = "desktop") {
  const [editors, setEditors] = useState([]);
  useEffect(() => {
    if (!projectId) return;
    let alive = true;
    const beat = async () => {
      try {
        const { data } = await api.post(`/projects/${projectId}/presence`, { device });
        if (alive) setEditors(data.editors || []);
      } catch { /* ignore transient errors */ }
    };
    beat();
    const t = setInterval(beat, 5000);
    return () => { alive = false; clearInterval(t); };
  }, [projectId, device]);
  return editors;
}

// Map of projectId -> [people] for the dashboard, refreshed every 8s.
export function usePresenceSummary() {
  const [summary, setSummary] = useState({});
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try { const { data } = await api.get("/presence/summary"); if (alive) setSummary(data || {}); } catch {}
    };
    load();
    const t = setInterval(load, 8000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return summary;
}
